/**
 * @enum GamingAggregatorStatusIdEnum
 * @description Defines status identifier constants for gaming aggregators in the system.
 * Each constant represents a different operational status with their assigned ID.
 */
export enum GamingAggregatorStatusIdEnum {
  /** @constant {bigint} Active - Aggregator is operational and active (ID: 1) */
  Active = 1,

  /** @constant {bigint} Suspended - Aggregator is temporarily suspended (ID: 2) */
  Suspended = 2,

  /** @constant {bigint} Inactive - Aggregator is not operational/inactive (ID: 3) */
  Inactive = 3,
}

/**
 * @description Type representing any valid gaming aggregator status ID value
 * @example const statusId: GamingAggregatorStatusIdTypeEnum = GamingAggregatorStatusIdEnum.Active;
 */
